module.exports = __webpack_public_path__ + "static/img/204_TO8_2116.4b3d661.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/204_TO8_2116.jpg
// module id = rZix
// module chunks = 0